<template>
  <div class="col s12 m12 push-top">
    <div class="card">
      <div class="card-image">
        <span class="card-title">{{ cardTitle }}</span>
      </div>
      <div class="card-content">
        <div class="col-full">
          <div class="row">
            <div class="card-content">
              <div class="iframe_container">
                <iframe
                  style="position: absolute; height: 100%; border: none; top: 0px;"
                  :src="iframeUrl"
                  frameborder="0"
                  width="100%"
                  class="iframe_style"
                  id="iframe_grafana"
                  @load="load"
                >
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iframeUrl: {
      required: true,
      type: String,
    },
    cardTitle: {
      required: true,
      type: String,
    },
  },
  methods: {
    load() {
      const tests = window.parent.document.getElementsByClassName(
        'react-grid-layout layout animated'
      );
      for (let i = 0; i < tests.length; i++) {
        tests.item(i).setAttribute('style', 'visibility:hidden;');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.iframe_container {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 78vh;
}

.iframe_style {
  margin-top: -57px;
  margin-left: -70px;
  height: inherit;
  width: calc(100vw + 50px) !important;
}

.push-top {
  margin-top: 12px;
  height: 100%;
  width: 100%;
}

.row {
  height: 100%;
  width: 100%;
}

.card {
  height: 100%;
  width: 100%;
}

.card-content {
  height: 100%;
  width: 100%;
  padding-left: 6px;
}

.card-title {
  text-decoration: none;
  background-color: $altYellow !important;
  color: white;
  text-align: center;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 2px;
  display: inline-block;
  height: 36px;
  line-height: 36px;
  padding: 0 16px !important;
  text-transform: uppercase;
  font-size: 1rem;
}

.btn,
.btn-large,
.btn-small {
  background-color: #41c0bc !important;
}
</style>
